import type { HelpFile } from '../../types/help'
import { LlmPromptsTestIds } from '../../../testids/LlmPromptsTestIds'

export const llmPromptsHelp: HelpFile = {
  docPage: '/docs/admin/llm-prompts',
  texts: {
    [LlmPromptsTestIds.llmPromptsList]: 'Prompt-Vorlagen für KI-gestützte Funktionen — SQL-Generierung, Tabellenauswahl, Migrations-Vorschläge und den Script-Assistenten.',
    [LlmPromptsTestIds.llmPromptsTable]: null,
    [LlmPromptsTestIds.colKey]: 'Maschinenkennung, über die das nutzende Feature die Vorlage referenziert (z. B. "sql-query").',
    [LlmPromptsTestIds.colDisplayName]: null,
    [LlmPromptsTestIds.colDescription]: null,
    [LlmPromptsTestIds.colLastUpdated]: null,
  },
}
